import React, { useState, useContext } from 'react';
import {
    Box,
    Button,
    TextField,
    Grid,
    Chip,
    CircularProgress,
    Link,
} from '@material-ui/core';
import { useTranslation } from "react-i18next";
import SecureFetchContext from 'context/SecureFetchContext';
import getApiRoute from 'routes/apiRoutes';
import Alert from '@material-ui/lab/Alert';
import { formatErrors } from 'helpers';

const SKPOST_COMPLAINT_EXCEL_URL = '/documents/ereklamacny-list_ecomplaint-form-zasielky-vnutrostatneho-styku-zmluvni-zakaznici.xls';

const ComplaintFormSkpostDamageForm = ({ className, data, ...rest }) => {
    const { t } = useTranslation();
    const secureFetch = useContext(SecureFetchContext);
    const [values, setValues] = useState({});
    const [files, setFiles] = useState([]);
    const [sending, setSending] = useState(false);
    const [submitError, setSubmitError] = useState(null);

    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    };

    const onFilesChange = (event) => {
        setFiles(Array.from(event.target.files));
        setSubmitError(null);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSubmitError(null);
        setSending(true);

        const formData = new FormData();
        formData.append('message', values.message || '');
        for (const file of files) {
            formData.append('files[]', file);
        }

        try {
            await secureFetch(getApiRoute('package', ['complaint', data.type, data.package.id]), formData, 'POST', false, false);
            setSending(null);
        } catch (e) {
            setSending(false);
            if (e && typeof e === 'object' && !Array.isArray(e)) {
                setSubmitError(formatErrors(e, t));
            } else {
                setSubmitError(e);
            }
        }
    };

    return (
        <form
            autoComplete="off"
            className={className}
            onSubmit={handleSubmit}
            {...rest}
        >
            <Grid container spacing={3} alignItems="center">
                <Grid item xs={12}>
                    <Alert severity="warning">
                        {t('messages.skpost_damage_form_info')}{' '}
                        <Link href={SKPOST_COMPLAINT_EXCEL_URL} target="_blank" rel="noopener noreferrer">
                            {t('label.skpost_claim_form_excel')}
                        </Link>
                        .
                    </Alert>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={t('label.message')}
                        name="message"
                        onChange={handleChange}
                        value={values.message || ''}
                        required
                        multiline
                        rows={5}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        component="label"
                    >
                        {t('button.add_attachment')}
                        <input
                            type="file"
                            name="files"
                            onChange={onFilesChange}
                            multiple
                            hidden
                        />
                    </Button>
                    {
                        files.map((file) => {
                            return (
                                <Box padding={1} display="inline" key={file.name}>
                                    <Chip label={file.name} />
                                </Box>
                            );
                        })
                    }
                </Grid>
                {submitError &&
                    <Grid item xs={12}>
                        <Alert variant="filled" severity="error">
                            {submitError}
                        </Alert>
                    </Grid>
                }
            </Grid>
            <Box display="flex" justifyContent="flex-start" py={2}>
                {
                    sending === null ?
                        <Alert variant="filled" severity="success">
                            {t('messages.sended')}
                        </Alert> :
                        <Button color="primary" variant="contained" type="submit" disabled={sending}>
                            {t('button.send')}
                            {
                                sending && <CircularProgress size={24} color="primary" />
                            }
                        </Button>
                }
            </Box>
        </form>
    );
};

export default ComplaintFormSkpostDamageForm;
